export type PackageSelectionItem = {
  balance?: number | string | null;
  qty?: number | string | null;
  header?: boolean;
  original?: { id?: number | string | null };
};

export type PackageSelectionPayload = {
  package_order_item: number | string;
  quantity_appointment: number | string;
};

export const hasValidPackageQuantity = (item: PackageSelectionItem): boolean => {
  const balance = Number(item.balance);
  const quantity = Number(item.qty);
  return (
    Number.isFinite(balance) &&
    Number.isFinite(quantity) &&
    balance > 0 &&
    quantity > 0 &&
    quantity <= balance
  );
};

export const getValidPackageSelection = (
  items: readonly PackageSelectionItem[],
  checkedIndexes: readonly number[],
): PackageSelectionPayload[] =>
  Array.from(new Set(checkedIndexes)).flatMap((index) => {
    const item = items[index];
    const id = item?.original?.id;
    if (!item || item.header || id == null || id === "" || !hasValidPackageQuantity(item)) {
      return [];
    }
    return [{ package_order_item: id, quantity_appointment: item.qty as number | string }];
  });
